﻿import $ from "jquery";
import "ElementQueries";

let showCalAlertOnce = true,
	showAlertCount = 0;

const consts = {
	programAttr: "data-program",

	ws22: "ws22",
	ws19: "ws19",

	activeClass: "ccs-logo-active",
	tabClass: "ccs-logo-winsrv2022-tab",
	showCalAlertClass: "ccs-logo-winsrv2022-show-cal-alert",
	footerActiveClass: "ccs-logo-winsrv2022-footer-active",
	ariaSelectedAttr: "aria-selected",
	
	wrapperSelector: ".ccs-logo-winsrv2022-wrapper",
	selectors: {
		tab: ".ccs-logo-winsrv2022-tabs a",
		slideShow: ".ccs-logo-winsrv2022-slideshow",
		slide: ".ccs-logo-winsrv2022-slide",
		calsImg: ".ccs-logo-winsrv2022-calsimg",
		returnToMain: ".ccs-logo-winsrv2022-return",
		accordionHeader: ".ccs-logo-winsrv2022-accordion-header",
		product: ".ccs-logo-winsrv2022-product",
		productQty: ".ccs-logo-winsrv2022-product-qty",
		backDrop: ".ccs-logo-winsrv2022-backdrop",
		calChartContent: ".ccs-logo-winsrv2022-calchart-content",
		accordion: ".ccs-logo-winsrv2022-accordion",
		accordionBody: ".ccs-logo-winsrv2022-accordion-body",
		accordionBodySection: ".ccs-logo-winsrv2022-accordion-body-section",
		equalizeContent: ".ccs-logo-winsrv2022-equalize",
		calModal: ".ccs-logo-winsrv2022-cal-modal",
		footerLink: ".ccs-logo-winsrv2022-footer-links a",
		logEvent: "[data-log-event]"
	}
};

function init(options) {
	const $ep = $(`#${options.entryPointId}`);

	if ($ep.length === 0) {
		return;
	}

	if (options.logoHoverId) {
		$ep.find(consts.wrapperSelector).attr("data-hoverid", options.logoHoverId);
	}

	initializeContents($ep);
	initializeNavigation($ep);
	initializeSlideShow($ep);
	initializeFooterLink($ep);

	initializeLogEvents(options.logEvent);

	$(document).on("ccsBreakpointFired", () => equalizeRows($ep));
}

function initializeContents($ep) {
	const tabContents = [
		$ep.find(`.ccs-logo-winsrv2022-servers:not(${consts.selectors.slideShow})`),
		$ep.find(`.ccs-logo-winsrv2022-cals:not(${consts.selectors.slideShow}):not(${consts.selectors.calsImg})`)
	];

	tabContents.forEach(($elements) => {
		if (!$elements.length) {
			return;
		}

		updateAttributes($elements);
	});
}

function updateAttributes($elements) {
	const programAttr = consts.programAttr;
	const programs = [consts.ws19, consts.ws22];

	programs.forEach((item) => {
		const $products = $elements.find(`li[${programAttr}=${item}]`);
		if (!$products.length) {
			return;
		}

		const oldAttr = $elements.attr(programAttr);
		if (oldAttr === undefined || oldAttr === null) {
			$elements.attr(programAttr, item);
			return;
		}

		if (oldAttr.indexOf(item) !== -1) {
			return;
		}

		$elements.attr(programAttr, `${oldAttr} ${item}`);
	});
}

function initializeNavigation($ep) {
	const selectors = consts.selectors;
	const initOnClickData = [{ selector: selectors.tab, func: tabOnClick },
	{ selector: selectors.returnToMain, func: returnToMain },
	{ selector: selectors.slide, func: slideOnClick },
	{ selector: selectors.accordionHeader, func: accordionHeaderOnClick },
	{ selector: selectors.backDrop, func: backDrop }];

	initOnClick($ep, initOnClickData);

	$ep.find(`${selectors.productQty} input[type="text"]`)
		.on("change", () => {
			var $obj = $(this);
			var q = $obj.val().replace(/[^0-9]/g, '');

			$obj.val(q);

			var parent = $obj.closest(selectors.productQty).parent();

			if (q > 0 && parent.hasClass(consts.showCalAlertClass)) {
				if (showCalAlertOnce || showAlertCount >= 1) {
					return;
				}

				$ep.find(selectors.calModal).show();
				showAlertCount++;
			}
		});
}

function initOnClick($ep, data) {
	data.forEach((item) =>
		$ep.on("click", item.selector,
			event => item.func($ep, $(event.currentTarget))
		)
	);
}

function tabOnClick($ep, $el) {
	if ($el.hasClass(consts.activeClass)) {
		return;
	}

	$el
		.closest("ul")
		.find("a")
		.removeClass(consts.activeClass)
		.attr(consts.ariaSelectedAttr, false);

	$el.addClass(consts.activeClass)
		.attr(consts.ariaSelectedAttr, true);;

	updateWrapperTabsTypeSelector($ep, $el);
	equalizeRows($ep);
}

function returnToMain($ep) {
	const c = consts;

	const $tab = $ep.find(`${c.selectors.calChartContent}:visible`).length > 0
		? $ep.find(c.wrapperSelector).find(`${c.selectors.tab}[data-type="cals"]`)
		: $ep.find(c.wrapperSelector).find(`${c.selectors.tab}[data-type="servers"]`);

	$tab
		.closest("ul")
		.find(c.selectors.tab)
		.each(() => $(this).removeClass(c.activeClass));

	if ($tab.hasClass(c.tabClass)) {
		$tab.addClass(c.activeClass);
	}

	updateWrapperTabsTypeSelector($ep, $tab);
	equalizeRows($ep);
}

function slideOnClick($ep, $el) {
	const c = consts;

	const $parent = $el.parent();
	const type = $parent.data("type");

	let $tabObj = $ep
		.find(c.wrapperSelector)
		.find(`${c.selectors.tab}[data-type="${type}"]`);

	$tabObj = $tabObj.length < 1 ? $parent : $tabObj;

	$tabObj
		.closest("ul")
		.find("a")
		.each((i, el) => $(el).removeClass(c.activeClass));

	if ($tabObj.hasClass(c.tabClass)) {
		$tabObj.addClass(c.activeClass);
	}

	updateWrapperTabsTypeSelector($ep, $tabObj);
	equalizeRows($ep);
}

function accordionHeaderOnClick($ep, $el) {
	const c = consts;

	const $accordion = $el.closest(c.selectors.accordion);
	const $accordionBody = $el.next(c.selectors.accordionBody);

	if ($accordion.hasClass(c.activeClass)) {
		$accordionBody.slideUp("fast", () => $(this).removeAttr("style"));
		$accordion.removeClass(c.activeClass);

		return;
	}

	$accordionBody.slideDown("slow", () => $(this).removeAttr("style"));
	$accordion.addClass(c.activeClass);
}

function backDrop($ep) {
	$ep.find(consts.wrapperSelector)
		.find(consts.selectors.calModal)
		.hide();
}

function updateWrapperTabsTypeSelector($ep, $el) {
	const dataType = $el.attr("data-type");

	$ep
		.find(consts.wrapperSelector)
		.attr("data-type", dataType);
}

function initializeSlideShow($ep) {
	const activeClass = consts.activeClass;

	$ep
		.find(consts.selectors.slideShow)
		.each((i, el) => {
			const $el = $(el);

			let $lastSlide = $el.find("a:visible:first");

			const l = $el.children().length;
			if (l <= 0) {
				return;
			}

			setInterval(() => {
				const i = $lastSlide.index();
				const next = i + 1 < l ? i + 1 : 0;

				$el.find("a").eq(i)
					.addClass(activeClass)
					.fadeOut(1000, () => $(this).removeClass(activeClass));

				$lastSlide = $el.find("a").eq(next);
				$lastSlide.show();
			}, 5000);
		});
}

function equalizeRows($ep) {
	const selectors = consts.selectors;

	$ep
		.find(selectors.accordionHeader)
		.height("auto");

	$ep.
		find(selectors.accordionBodySection)
		.height("auto");

	const $tbl = $ep.find(`${selectors.equalizeContent}:visible`);
	if ($tbl.length <= 0) {
		return;
	}

	const data = [];

	$tbl
		.find(selectors.accordion)
		.each((index, el) => {
			const $el = $(el);
			const headerHeight = $el.find(selectors.accordionHeader).height();

			let dataIndex = 0;

			data[dataIndex] = data[dataIndex] || [];
			data[dataIndex].push(headerHeight);

			$el
				.find(selectors.accordionBodySection)
				.each((index, el) => {
					dataIndex++;

					const height = $(el).height();

					data[dataIndex] = data[dataIndex] || [];
					data[dataIndex].push(height);
				});
		});

	for (var i in data) {
		if (!data.hasOwnProperty(i)) {
			continue;
		}

		data[i].sort((a, b) => b - a);

		const height = data[i][0];

		$tbl
			.find(selectors.accordion)
			.each((index, el) => {
				const $el = i == 0
					? $(el).find(selectors.accordionHeader)
					: $(el).find(selectors.accordionBodySection).eq(i - 1);

				$el.height(height);
			});
	}
}

function initializeFooterLink($ep) {
	const s = consts.selectors;

	if (!$ep.find(`${s.product}[${consts.programAttr}=${consts.ws19}]`).length) {
		$ep.find(s.footerLink).hide();
		return;
	}

	initOnClick($ep, [{ selector: s.footerLink, func: footerLinkOnClick }]);
}

function footerLinkOnClick($ep, $el) {
	const $wrapper = $ep.find(consts.wrapperSelector);
	const attr = $wrapper.attr(consts.programAttr) === consts.ws22
		? consts.ws19
		: consts.ws22;

	const hoverid = $wrapper.attr("data-hoverid");

	$wrapper.attr(consts.programAttr, attr);

	if (hoverid) {
		$("#"+hoverid).attr(consts.programAttr, attr);
	}

	updateFooterLinkText($ep, attr);
	updateActiveTab($ep);
}

function updateActiveTab($ep) {
	const $tabs = $ep.find(consts.selectors.tab);
	const activeTabIsVisible = $tabs
		.filter((i, el) => $(el).is(`.${consts.activeClass}:visible`))
		.length > 0;

	if (activeTabIsVisible) {
		return;
	}

	$tabs.toggleClass(consts.activeClass);

	updateWrapperTabsTypeSelector($ep, $tabs.filter((i, el) => $(el).is(`.${consts.activeClass}:visible`)));
	equalizeRows($ep);
}

function updateFooterLinkText($ep, attr) {
	const $footerLink = $ep.find(consts.selectors.footerLink);
	let footerText = $footerLink.text();

	footerText = attr === consts.ws19
		? footerText.replace("19", "22")
		: footerText.replace("22", "19");

	$footerLink.text(footerText);
}

function initializeLogEvents(logEvent) {
	const c = consts;

	$(c.selectors.logEvent)
		.on("click", (e) => {
			const param = $(e.currentTarget).data("log-event");
			const clientParams = { ActionContext: param };

			ccs_cc_log.dispatchEvent(logEvent, clientParams);
		});
}

export default { init };